import type { MouseEvent } from 'react';
import { faBullhorn } from '@awesome.me/kit-4a6bf60416/icons/classic/regular';

import { Button } from '@/components/ui/button';
import { Icon } from '@/components/ui/icon';
import { getDocument } from '@/lib/utils';

export function getReceivedReviewsNotificationLabel(count: number) {
  return `${count} new ${count === 1 ? 'review' : 'reviews'} received`;
}

export function ReceivedReviewsNotificationBanner({
  count,
  onDismiss,
  onViewLatestReceivedReviews,
}: {
  count: number;
  onDismiss: () => void;
  onViewLatestReceivedReviews: () => Promise<void> | void;
}) {
  const scrollToReceivedReviews = async (e: MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    await onViewLatestReceivedReviews();
    getDocument()
      ?.getElementById('received-reviews-section')
      ?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <div className="flex items-center justify-between gap-4 rounded-lg bg-primary/[0.04] px-4 py-3 text-sm font-medium text-primary">
      <div className="flex items-center gap-2">
        <Icon icon={faBullhorn} size="sm" />
        <Button
          variant="link"
          className="whitespace-normal text-left"
          onClick={scrollToReceivedReviews}
        >
          {getReceivedReviewsNotificationLabel(count)}
        </Button>
      </div>
      <Button
        variant="link"
        className="shrink-0 text-sm font-medium text-primary transition hover:opacity-80"
        onClick={onDismiss}
        aria-label="Dismiss received reviews notification"
      >
        Dismiss
      </Button>
    </div>
  );
}
